import React from 'react';

interface FindUsWorldwideProps {
  visibleElements: Set<string>;
  platformsRef: React.RefObject<HTMLDivElement | null>;
}

export default function FindUsWorldwide({ visibleElements, platformsRef }: FindUsWorldwideProps) {
  return (
    <div className="relative py-24 sm:py-32 bg-gradient-to-br from-neutral-900 via-neutral-800 to-neutral-900 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/20 to-secondary-600/20" />
        <div className="w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>
      
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8">
        <div 
          className={`text-center mb-16 transition-all duration-1000 ease-out transform ${
            visibleElements.has('platforms') 
              ? 'opacity-100 translate-y-0 scale-100' 
              : 'opacity-0 translate-y-16 scale-95'
          }`}
        >
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6">
            Find us worldwide
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Find us on various platforms worldwide. Connect with us on our multiple online platforms 
            and discover a world of possibilities at your fingertips.
          </p>
        </div>        <div 
          ref={platformsRef}
          data-animate="platforms"
          className={`grid grid-cols-5 gap-2 sm:gap-3 max-w-lg sm:max-w-xl mx-auto transition-all duration-1000 ease-out transform ${
            visibleElements.has('platforms') 
              ? 'opacity-100 translate-y-0 scale-100' 
              : 'opacity-0 translate-y-20 scale-95'
          }`}        ><a
            href="https://www.tripadvisor.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-md p-1 sm:p-2 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex items-center justify-center aspect-square"
          >
            <img
              src="/images/booking/tripadvisor.png"
              alt="TripAdvisor"
              className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
            />
          </a>          {/* Booking.com */}
          <a
            href="https://www.booking.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-md p-1 sm:p-2 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex items-center justify-center aspect-square"
          >
            <img
              src="/images/booking/booking.png"
              alt="Booking.com"
              className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
            />          </a>          {/* Trivago */}
          <a
            href="https://www.trivago.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-md p-1 sm:p-2 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex items-center justify-center aspect-square"
          >
            <img
              src="/images/booking/trivago.png"
              alt="Trivago"
              className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
            />
          </a>          {/* Agoda */}
          <a
            href="https://www.agoda.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-md p-1 sm:p-2 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex items-center justify-center aspect-square"
          >
            <img
              src="/images/booking/agoda.png"
              alt="Agoda"
              className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
            />          </a>          {/* More Platforms - Placeholder for future expansion */}
          <div className="group bg-gradient-to-br from-primary-500 to-secondary-500 rounded-md p-1 sm:p-2 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 flex items-center justify-center aspect-square">
            <div className="text-center">
              <div className="text-white text-sm sm:text-lg font-bold mb-0.5">+</div>
              <div className="text-white text-[10px] sm:text-xs font-medium">More</div>
            </div>
          </div>        </div>
      </div>
    </div>
  );
}
